module.exports = __webpack_public_path__ + "img/amazon.bc68f7df.svg";